import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { NotebookPen, ChevronRight } from "lucide-react";
import { Card } from "@/components/ui/card";
import BioDueChip from "@/components/bios/BioDueChip";
import api from "@/lib/api";

// Member dashboard card, shown only after a director nudge and until the member saves a bio.
export default function BioPromptCard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/bios/my").then(({ data: d }) => setData(d)).catch(() => {}); }, []);
  if (!data?.enabled || !data.nudged) return null;
  return (
    <Link to="/member/profile?section=bio" className="mb-4 block" data-testid="bio-prompt-link">
      <Card className="flex items-center gap-4 border-slate-200 bg-white p-4 shadow-sm transition-shadow hover:shadow-md animate-fade-in-up" data-testid="bio-prompt-card">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-sky-100 text-sky-700 ring-1 ring-sky-200"><NotebookPen className="h-5 w-5" /></span>
        <div className="min-w-0 flex-1">
          <p className="flex flex-wrap items-center gap-2 font-heading text-base font-bold text-slate-900">Complete your bio <BioDueChip deadline={data.deadline} testId="bio-prompt-due" /></p>
          <p className="text-sm text-slate-500">Your director asked you to add a short bio for programs and playbills. This card goes away once you save it.</p>
        </div>
        <span className="hidden shrink-0 rounded-full bg-slate-900 px-4 py-1.5 text-sm font-semibold text-white sm:inline-flex" data-testid="bio-prompt-cta">Write my bio</span>
        <ChevronRight className="h-5 w-5 shrink-0 text-slate-300 sm:hidden" />
      </Card>
    </Link>
  );
}
